import {
  Directive,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  NgZone,
  Input,
} from "@angular/core";

@Directive({ selector: "[nisDroppable]" })
export class DroppableDirective implements AfterViewInit {
  $el: any;
  @Output() drop: EventEmitter<any> = new EventEmitter();

  @Input()
  droppable;

  constructor(private el: ElementRef, private zone: NgZone) {
    this.$el = $(el.nativeElement);
  }

  ngAfterViewInit() {
    this.droppable.classes = {
      "ui-droppable-active": "droppable-active",
      "ui-droppable-hover": "droppable-hover",
    };
    this.droppable.drop = (event, ui) => {
      this.zone.run(() => {
        console.log("drop event detected");
        this.drop.emit({ event: event, ui: ui });
      });
    };
    setTimeout(() => {
      (<any>this.$el).droppable(this.droppable);
    }, 100);
  }
}
